import INApi from './_inApi.js';
import httpClient from '@/apis/base/httpclient';

class InInwardOutwardAPI extends INApi {
  constructor() {
    super();
  }
  controllerName = 'InInwardOutwards';

  getDataVoucher(payload) {
    let request = {
      url: this.getAPIUrl() + '/DataVoucher',
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  getLastestInwardOutward(payload) {
    let request = {
      url: this.getAPIUrl() + '/GetLastestInwardOutward',
      data: payload,
    };

    return httpClient.postAsync(request);
  }

}
export default new InInwardOutwardAPI();
